// ui/src/helpers/datetime/core.ts
import { TZDate } from '@date-fns/tz';

import { jotaiStore } from '@/providers/jotai/jotai-store';
import { timezoneAtom } from '@/state/time.state';

export type DateInput = Date | string | number;

/**
 * Creates a TZDate in the specified timezone.
 * Shared base for createUTCDate and createFacilityDate.
 */
export function createTZDate(date: DateInput | undefined, timeZone: string): TZDate {
  const resolved = date ? new Date(date) : new Date();
  return new TZDate(resolved, timeZone);
}

export function getFacilityTimeZone(): string {
  return jotaiStore.get(timezoneAtom);
}
